import React, {useState} from 'react';
import {Box, Flex, Heading, IconButton} from '@tempo/core';
import {CrossIcon, VolumeMaxIcon, VolumeMuteIcon} from '@tempo/icons';

import {useBridge} from '@providers/BridgeProvider';
import {useLogContext} from '@providers/LogProvider';

import {Durations} from '@modules/constants';

type HeaderProps = {
	color: string;
	title?: string;
	muteAction?: boolean;
	cardId: string;
};

const Header = ({color, title, muteAction = true, cardId}: HeaderProps) => {
	const [isMute, setIsMute] = useState(false);
	const bridge = useBridge();
	const logContext = useLogContext();

	return (
		<Box position="absolute" top={0} left={0} w="full" zIndex="2" dir="ltr">
			<Flex
				className="pagination-position"
				w="full"
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
				flexWrap="nowrap"
				gap={'4px'}
				px="8px"
				py={2}
				style={{
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					'--swiper-pagination-color': color,
					'--swiper-pagination-bullet-inactive-color': color,
					'--swiper-pagination-bullet-inactive-opacity': '0.2',
				}}
			/>
			<Flex
				alignItems="center"
				justifyContent="space-between"
				w="full"
				px="8px"
				py={0}
				zIndex={2}
			>
				{title ? (
					<Heading
						fontSize="16px"
						color={color}
						transition={Durations.colorTransitionDuration}
					>
						{title}
					</Heading>
				) : (
					<Box />
				)}

				<Box>
					{muteAction && bridge && (
						<IconButton
							aria-label="Volume"
							transition={Durations.colorTransitionDuration}
							color={color}
							variant="ghost"
							onClick={() => {
								setIsMute(!isMute);
								bridge.muteAudio(!isMute);
							}}
							icon={
								isMute ? (
									<VolumeMuteIcon boxSize={6} />
								) : (
									<VolumeMaxIcon boxSize={6} />
								)
							}
						/>
					)}
					{bridge && (
						<IconButton
							transition={Durations.colorTransitionDuration}
							aria-label="Close"
							color={color}
							onClick={() => {
								// Log event
								if (cardId) {
									logContext?.logEvent('my_deezer_year_used', {
										cardName: cardId,
										action: 'close',
									});
								}
								bridge.closeScreen();
							}}
							icon={<CrossIcon boxSize={6} />}
							variant="ghost"
						/>
					)}
				</Box>
			</Flex>
		</Box>
	);
};

export default Header;
